"use client";

import { ReactNode } from "react";
import { DialogsProvider } from "@/lib/context/dialogs.context";

export function DialogsProviderWithDialogs({
  children,
}: {
  children: ReactNode;
}) {
  return <DialogsProvider>{children}</DialogsProvider>;
}
